import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Mail, Loader2, CheckCircle2 } from 'lucide-react';
import { API } from '../../lib/constants';
import { Field } from '../AuthShell';

export const ResendLinkCard = ({ slug, initialEmail = '', compact = false }) => {
  const [email, setEmail] = useState(initialEmail);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const { data } = await axios.post(`${API}/public/resend-link`, { email, tenant_slug: slug });
      setSent(data.message);
    } catch (err) {
      toast.error(err.response?.data?.detail?.[0]?.msg || 'Please enter a valid email');
    } finally {
      setSending(false);
    }
  };

  if (sent) {
    return (
      <div className="border-2 border-lime bg-lime/10 p-4 flex items-start gap-3" data-testid="resend-link-success">
        <CheckCircle2 className="w-5 h-5 text-lime shrink-0 mt-0.5" />
        <div>
          <p className="text-sm text-white font-semibold">Check your inbox</p>
          <p className="text-xs text-slate-300 mt-1">{sent}</p>
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className={compact ? 'space-y-3' : 'card p-5 space-y-4'} data-testid="resend-link-card">
      {!compact && (
        <div>
          <h3 className="h-display text-base flex items-center gap-2"><Mail className="w-4 h-4 text-cyan" /> Already registered?</h3>
          <p className="text-xs text-slate-400 mt-1">Enter the email you registered with and we'll send your private album link.</p>
        </div>
      )}
      <Field label="Email address">
        <input data-testid="resend-email-input" type="email" required className="input !py-2.5" placeholder="jane@example.com" value={email} onChange={(e) => setEmail(e.target.value)} />
      </Field>
      <button data-testid="resend-link-btn" type="submit" disabled={sending || !email} className="btn-secondary w-full !py-3">
        {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mail className="w-4 h-4" />} Email me my album link
      </button>
    </form>
  );
};
